import {GetterTree} from "vuex";
import {DuplicatesState} from "@/store/settings/duplicates/types";
import {RootState} from "@/store/types";

export const getters: GetterTree<DuplicatesState, RootState> = {
  duplicates:state => state.duplicates,
  duplicateItem:state => state.duplicateItem
}